module.exports = __webpack_public_path__ + "media/video.dd40c240.mp4";